import { getOptions } from 'components/common/InputSelect/inputSelect.utils';

import {
  BusinessEntityStructure,
  DefaultYesNoQuestion,
  OwnersAmount,
  OwnersPosition,
  PrimaryHomeImprovementCategory,
  PrequalificationStep,
} from './registrationProcess.enums';

export const REGISTRATION_STEPS: PrequalificationStep[] = [
  PrequalificationStep.BusinessInformation,
  PrequalificationStep.AddressInformation,
  PrequalificationStep.BusinessMetrics,
  PrequalificationStep.Owners,
];

export const BUSINESS_ENTITY_STRUCTURE_OPTIONS = getOptions(BusinessEntityStructure);
export const PRIMARY_HOME_IMPROVEMENT_CATEGORY_OPTIONS = getOptions(PrimaryHomeImprovementCategory);
export const DEFAULT_YES_NO_QUESTION_OPTIONS = getOptions(DefaultYesNoQuestion);
export const OWNER_POSITION_OPTIONS = getOptions(OwnersPosition);
export const HOW_MANY_OWNERS_OPTIONS = getOptions(OwnersAmount);
export const FEDERAL_TAX_ID_WITH_DASH_MAX_LENGTH = 10;
export const DEPRECATED_FEDERAL_TAX_IDS = ['00-0000000'];
export const MAX_INTERMEDIARY_OWNERS = 4;
export const PREQUALIFICATION_STEPS_ORDER: Record<PrequalificationStep, number> = {
  [PrequalificationStep.BusinessInformation]: 1,
  [PrequalificationStep.AddressInformation]: 2,
  [PrequalificationStep.BusinessMetrics]: 3,
  [PrequalificationStep.Owners]: 4,
};
export const CONFLICT_ERROR_STATUS_CODE = 409;
export const ONE_HOUR_TIMER = 60 * 60 * 1000;
export const HALF_HOUR_TIMER = 30 * 60 * 1000;
export const TOTAL_PERCENTAGE_OWNED_MAX_VALUE = 100;
export const OWNERS_FORM_DATA_SESSION_STORAGE_KEY = 'owners_form_backup';
export const BUSINESS_INFORMATION_FORM_DATA_SESSION_STORAGE_KEY = 'business_information_form_backup';
export const EXISTING_USER_ERROR_MESSAGE = 'User with same email already exists.';
export const INVITE_TO_PORTAL_SENT_SIDE_BAR_SHOWED_SESSION_STORAGE_KEY = 'invite_to_portal_sent_side_bar_showed';
